import { min, max } from 'date-fns';

/**
 * Clamps a date between a minimum and maximum value.
 *
 * @param {Date} date The date to clamp
 * @param {Date} minDate The minimum date
 * @param {Date} maxDate The maximum date
 */
export function dateClamp(date, minDate, maxDate) {
	return min([max([date, minDate]), maxDate]);
}
